import React from 'react';

const SkeletonLoader = ({ count, isMobile }) => {
  return (
    <>
      {Array(count)
        .fill(0)
        .map((_, index) => (
            <div
             key={index}
                className="col-lg-4 col-md-12 col-sm-12"
                style={{ pointerEvents: 'none' }}
              >
                <div className="card h-100 shadow-sm skeleton">
                  
                  <img
                   src='./videoPlaceholder.png'
                    alt="Loading..."
                    className="card-img-top skeleton"
                    style={{ height: "50%", objectFit: "cover", width: "100%" }}
                    onError={(e) => (e.target.src = "/videoPlaceholder.png")}
                  />

                 
                  <div className="card-body position-relative">
                    <h5
                      className="card-title skeleton"
                      style={{ backgroundColor:'rgb(207 206 206)',color: "rgb(2 75 155)", fontFamily: "poppins", borderTop: "2px solid #c8c5c5", paddingTop: "10px", fontSize: "1.1rem" }}
                    >
                      <span style={{visibility:'hidden'}}>Hello There</span>
                      
                    </h5>
                    <p className="card-text text-muted"></p>

                    <span className="badge skeleton position-absolute bottom-0 start-0 m-3" style={{ backgroundColor: "#c8c5c5"}}>
                      <span style={{visibility:'hidden'}}>00:00</span>
                    </span>
                  </div>
                </div>
              
          </div>
        ))}
        </>
  );
};

export default SkeletonLoader;
